// Read synchronously rather than via useQuery — a synchronous queryFn drives a re-render loop on
// react-query 5.101 (issue #1027). localStorage is the source of truth and the read is cheap.
export const useFocusedPaymentMethodId = (): string | null => localStorage.getItem('focused_payment_method_id');
